import { captureException } from '@quintoandar/fwp-error-monitoring';
import { getUser } from 'utils/user';
import { fromJSON } from 'transit-immutable-js';

export const logUncaught = (err, context) => {
  if (process.env.SENTRY_DSN !== undefined) {
    const user = getUser();

    captureException(err, {
      extra: {
        context,
        localStorage: getLocalStorage(),
      },
      tags: {
        userId: user.user_id,
        userAgentId: user.userAgentId,
      },
      contexts: {
        react: {
          componentStack: context?.componentStack,
        },
      },
    });
  }
};

function parseStorageData(data) {
  try {
    return JSON.parse(data);
  } catch (e) {
    return {};
  }
}

function getLocalStorage() {
  const data = {};

  try {
    const storage = localStorage;

    Object.keys(localStorage).forEach((key) => {
      let keyData = parseStorageData(storage[key]);

      if (/ (persist) /.test(key)) {
        keyData = fromJSON(keyData);
      }

      data[key] = typeof keyData.toJS === 'function' ? keyData.toJS() : keyData;
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Could not retrieve localStorage data to sentry');
  }

  return data;
}

export const logFailure = ({ message, state, payload }) => {
  logUncaught(new Error(message), {
    state,
    payload,
  });
};
